export default class Move
{
    constructor()
    {
        this.playerID = null;
        this.beadID = null;
        this.holeNumber = null;
    }
}